import camelCase from 'lodash/camelCase';
import startCase from 'lodash/startCase';

export function camelCaseToTitleCase(str: string): string {
  return startCase(camelCase(str));
}
/**
 * Converts a camelCase string to Title Case with proper abbreviation handling
 * Examples:
 * - "isPtoGranted" -> "Is PTO Granted"
 * - "customerFirstName" -> "Customer First Name"
 * - "solarSystemSizeKw" -> "Solar System Size KW"
 * - "batteryCapacityKwh" -> "Battery Capacity kWh"
 * - "utilityAccountNumber" -> "Utility Account Number"
 */
export const camelCaseToTitleCaseSpecial = (str: string): string => {
  // Special cases for specific formatting
  const specialCases = new Map([['kwh', 'kWh']]);

  // Common abbreviations that should be uppercase
  const abbreviations = new Set(['pto', 'ac', 'dc', 'kw', 'url', 'id', 'usa', 'hvac', 'pv']);

  return (
    str
      // Insert spaces before uppercase letters
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      // Split into words
      .split(' ')
      .map((word) => {
        const lowerWord = word.toLowerCase();

        // Check for special cases first
        if (specialCases.has(lowerWord)) {
          return specialCases.get(lowerWord)!;
        }

        // Check if it's a known abbreviation
        if (abbreviations.has(lowerWord)) {
          return lowerWord.toUpperCase();
        }

        // Capitalize first letter of regular words
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(' ')
  );
};
